import { BillingItemKind, BillingItemType, Kpd } from "./types";

export const transformBillingItemKind = (res: any): BillingItemKind => ({
  id: res.id,
  name: res.name,
  sortOrder: res.sortOrder ?? 0,
});

export const transformBillingItemType = (res: any): BillingItemType => ({
  id: res.id,
  code: res.code,
  name: res.name,
  billingItemKindId: res.billingItemKindId ?? null,
  billingItemKindName: res.billingItemKindName ?? null,
  isRecurring: res.isRecurring ?? false,
  defaultQuantity: res.defaultQuantity ?? null,
  defaultUnitOfMeasureId: res.defaultUnitOfMeasureId ?? null,
  defaultUnitOfMeasureSymbol: res.defaultUnitOfMeasureSymbol ?? null,
  defaultTaxRate: res.defaultTaxRate ?? null,
  defaultPriceWithoutTax: res.defaultPriceWithoutTax ?? null,
  defaultKpdCode: res.defaultKpdCode ?? null,
  defaultNote: res.defaultNote ?? null,
  isSystem: res.isSystem ?? false,
  isActive: res.isActive ?? true,
  sortOrder: res.sortOrder ?? null,
});

export const transformKpd = (res: any): Kpd => ({
  id: res.id,
  code: res.code,
  name: res.name,
});
